import {createContext} from 'react'

import {EventData} from '../declarations'

export const EventContext = createContext<EventData>({})
